// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfr_a"};